import angular from 'angular';
import Factory from './Factory.js';

class AppConfiguration {
    constructor() {
        this._config = null;
        this.factory = new Factory();
    }

    configure(config) {
        this._config = config;
    }

    $get() {

        var appConf = () => {
            return this._config;
        };

        appConf.application = this.application.bind(this);
        appConf.menu = this.menu.bind(this);
        appConf.entity = this.entity.bind(this);
        appConf.configure = this.configure.bind(this);
        appConf.field = this.field.bind(this);
        // appConf.setFactory = this.setFactory.bind(this);

        return appConf;
    }

    application(name) {
        return this.factory.application(name);
    }

    menu(entity){
        return this.factory.menu(entity);
    }

    entity(name) {
        return this.factory.entity(name);
    }

    field(name, type) {
        return this.factory.field(name, type);
    }

    setfactroy(factory) {
        this.factory = factory;
    }
}

// class AppConfigurationUIRouter extends AppConfiguration {

//     $get($state) {

//     }
// }


const configurationModule = angular.module('ConfigurationModule', []);

configurationModule.provider('AppConfiguration', AppConfiguration);

export {configurationModule};



// WEBPACK FOOTER //
// ./app/components/common/configuration/configuration.js